import Head from 'next/head'
import PageHeader from '@components/PageHeader'
import Skills from '@components/Skills'
import { NextPage } from 'next'
import { Container, ContainerSlim } from '@components/styled'
import { Grid as BoxesGrid, Item as BoxesGridItem } from '@components/BoxesGrid'
import Section from '@components/Section'
import HR from '@components/HR'
import SectionHeading from '@components/Headings/SectionHeading'
import Marquee from '@components/Marquee'
import Tile from '@components/Tile'
import Text from '@components/Text'
import { H4 } from '@components/Heading'
import { Slider as ProcessSlider } from '@components/Process'
import FooterProjectsCTA from '@components/FooterProjectsCTA'

const WhatWeDoPage: NextPage = () => (
  <>
    <Head>
      <title>What we do</title>
    </Head>
    <PageHeader
      title={[['We make', 'your business', 'visible']]}
      floatingText="Because we can."
    />

    <Container>
      <BoxesGrid className="mb-80 mb-md-200" layout="fill-gray">
        <BoxesGridItem
          icon={<img src="icons/set-3/web-development.svg" alt="" />}
          title={
            <span>
              Web
              <br />
              development
            </span>
          }
        />
        <BoxesGridItem
          icon={<img src="icons/set-3/e-commerce.svg" alt="" />}
          title="E-commerce"
        />
        <BoxesGridItem
          icon={<img src="icons/set-3/mobile-development.svg" alt="" />}
          title={
            <span>
              Mobile
              <br />
              development
            </span>
          }
        />
        <BoxesGridItem
          icon={<img src="icons/set-3/product-design.svg" alt="" />}
          title={
            <span>
              Product
              <br />
              design
            </span>
          }
        />
        <BoxesGridItem
          icon={<img src="icons/set-3/tech-partnership.svg" alt="" />}
          title={
            <span>
              Tech
              <br />
              partnership
            </span>
          }
        />
      </BoxesGrid>
    </Container>

    <div className="mb-80 mb-md-200">
      <Skills />
    </div>

    <Section>
      <Container>
        <div>
          <HR className="mb-24" />
          <SectionHeading title="Our Process" />
        </div>
      </Container>
      <ProcessSlider />
    </Section>
    <Section className="mb-80 mb-md-200" style={{ paddingTop: 0 }}>
      <Container>
        <div>
          <HR className="mb-24" />
          <SectionHeading title="Technologies and tools" />
        </div>
      </Container>
      <Marquee componentWidth="200px" reverse>
        <Tile
          imageUrl="images/logos/technologies/bootstrap.svg"
          title="Bootstrap"
        />
        <Tile imageUrl="images/logos/technologies/css.svg" title="CSS" />
        <Tile imageUrl="images/logos/technologies/docker.svg" title="Docker" />
        <Tile imageUrl="images/logos/technologies/gitlab.svg" title="GitLab" />
        <Tile imageUrl="images/logos/technologies/html.svg" title="HTML" />
        <Tile
          imageUrl="images/logos/technologies/invision.svg"
          title="Invision"
        />
        <Tile imageUrl="images/logos/technologies/jira.svg" title="Jira" />
      </Marquee>
      <div style={{ marginBottom: '1.6rem' }} />
      <Marquee componentWidth="200px">
        <Tile key="JS" imageUrl="images/logos/technologies/js.svg" title="JS" />
        <Tile imageUrl="images/logos/technologies/mysql.svg" title="MYSQL" />
        <Tile imageUrl="images/logos/technologies/php.svg" title="PHP" />
        <Tile
          imageUrl="images/logos/technologies/rabbitMQ.svg"
          title="rabbitMQ"
        />
        <Tile imageUrl="images/logos/technologies/react.svg" title="React" />
        <Tile imageUrl="images/logos/technologies/sketch.svg" title="Sketch" />
        <Tile imageUrl="images/logos/technologies/slack.svg" title="Slack" />
        <Tile
          imageUrl="images/logos/technologies/symfony.svg"
          title="Symfony"
        />
        <Tile imageUrl="images/logos/technologies/uxpin.svg" title="UXPin" />
      </Marquee>
    </Section>

    <ContainerSlim className="mb-80 mb-md-128 text-center">
      <H4 as="h2">How do our services stand out?</H4>
      <Text className="my-0" size="big" color="gray">
        Creativity is not reserved only for masterpieces. Although, we have to
        say it - our project merges arts and technologies into a harmonious
        whole. Unusual ideas combined with your vision - it will work! Our
        services stand out for looking at projects holistically with attention
        to even the smallest details. We keep the business aspects in mind, our
        partners’ goals and the visual and functional sides of the project.
      </Text>
    </ContainerSlim>

    <Container>
      <BoxesGrid className="mb-80 mb-md-160" layout="simple-separator">
        <BoxesGridItem
          icon={<img src="icons/set-2/functionality.svg" alt="" />}
          title="Functionality"
        />
        <BoxesGridItem
          icon={<img src="icons/set-2/simple-service.svg" alt="" />}
          title={
            <span>
              Simple
              <br />
              service
            </span>
          }
        />
        <BoxesGridItem
          icon={<img src="icons/set-2/unique-design.svg" alt="" />}
          title={
            <span>
              Unique
              <br />
              design
            </span>
          }
        />
        <BoxesGridItem
          icon={<img src="icons/set-2/fast-operation.svg" alt="" />}
          title={
            <span>
              Fast
              <br />
              operation
            </span>
          }
        />
        <BoxesGridItem
          icon={<img src="icons/set-2/easy-development.svg" alt="" />}
          title={
            <span>
              Easy
              <br />
              development
            </span>
          }
        />
      </BoxesGrid>
    </Container>

    <FooterProjectsCTA />
  </>
)

export default WhatWeDoPage
